import React from 'react';
import styled from 'styled-components';
import { useLocation } from 'react-router-dom';
import { Menus } from '../Menus/Menus';
import styles from './Sidebar.styles';

const StyledAside = styled.aside`
  ${styles.container}
`;

export function Sidebar() {
  const location = useLocation();

  return (
    <StyledAside>
      <Menus currentPath={location.pathname} />
    </StyledAside>
  );
}

export default Sidebar;
